import React from 'react';
import Immutable from 'immutable';

import component from './component';
import Header from './Header';
import Footer from './Footer';
import Search from './Search';
import Indicator from './Indicator';
import Form from './Form';
import DataDisplay from './DataDisplay';
import TopBanner from './TopBanner';
import ModalAlert from './ModalAlert';

import HomePage from './pages/Home';
import TournamentsPage from './pages/Tournaments';
import TournamentDetails from './pages/TournamentDetails';
import TournamentStage from './pages/TournamentStage';
import TournamentRules from './pages/TournamentRules';
import TournamentTeamsList from './pages/TournamentTeamsList';
import TeamsPage from './pages/Teams';
import TeamDetails from './pages/TeamDetails';
import PlayersPage from './pages/Players';
import PlayerDetails from './pages/PlayerDetails';
import GameDetails from './pages/GameDetails';
import FlatPage from './pages/FlatPage';
import SignInPage from './pages/SignIn';
import Faq from './pages/Faq';
import NewsHomePage from './pages/NewsHome';
import NewsPage from './pages/News';
import Sitemap from './pages/Sitemap';
import Feedback from './pages/Feedback';
import Playground from './pages/Playground';
import Error from './pages/Error';


const pages = {

  home(data, params) {
    return <HomePage data={data} params={params} />;
  },

  newsHome(data, params) {
    return <NewsHomePage data={data} params={params} />
  },

  newsDetails(data, params) {
    return <NewsPage data={data} params={params} />
  },

  tournaments(data, params, query) {
    return <TournamentsPage data={data} params={params} query={query} />;
  },

  tournamentDetails(data, params, query) {
    return <TournamentDetails data={data} params={params} query={query} />;
  },

  tournamentRules(data, params, query) {
    return <TournamentRules data={data} params={params} query={query} />;
  },

  tournamentTeamsList(data, params, query) {
    return <TournamentTeamsList data={data} params={params} query={query} />;
  },

  tournamentStage(data, params, query) {
    return <TournamentStage data={data} params={params} query={query} />;
  },

  tournamentStageInner(data, params, query) {
    return <TournamentStage data={data} params={params} query={query} />;
  },

  teams(data, params, query) {
    return <TeamsPage data={data} params={params} query={query} />;
  },

  teamsNew(data, params){
    return <TeamDetails data={data} params={params} isNew={true} />
  },

  teamDetails(data, params){
    return <TeamDetails data={data} params={params} />
  },
  players(data, params, query) {
    return <PlayersPage data={data} params={params} query={query} />;
  },

  playerDetails(data, params){
    return <PlayerDetails data={data} params={params} />;
  },

  gameDetails(data, {id}) {
    return <GameDetails data={data} gameId={parseInt(id)} />;
  },

  faq(data) {
    return <Faq data={data} />;
  },

  sitemap(data) {
    //return <Form data={data.cursor('form')} />;
    return <Sitemap data={data} />
  },

  feedback(data) {
    return <Feedback data={data} />
  },

  404(data) {
    return <Error code={404} />;
  },

  500() {
    return <Error code={500} />;
  },

  signin(data) {
    return <SignInPage data={data} />;
  },

  flatPage(data, {id}) {
    return <FlatPage data={data.cursor(['flatPagesData', parseInt(id)])} />;
  },

  playground(data) {
    return <Playground data={data} />;
  }
};


export default component('Layout', function({data}) {
  const pageName = data.cursor(['route', 'name']).deref();
  const params = data.cursor(['route', 'params']).deref().toJS();
  const query = data.cursor(['route', 'query']).deref().toJS();
  const popup = data.cursor('popup');

  return (
    <div className='Layout'>
      <Header data={data} />
      <div className="Content">
        {pages[pageName](data, params, query)}
      </div>
      <DataDisplay data={data} exclude={[
        ['popup', 'onAction'],
        ['popup', 'onActionAsync'],
        ['popup', 'icon']
      ]} />
      <Footer data={data} />
      {
        popup.deref() &&
          <ModalAlert {...popup.toJS()} onClose={() => popup.remove()} />
      }
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/Layout.js